export const Colors = {
    mainColor: 'white',
    notMainColor: 'black',
    checkboxBG: 'white',
    cobalt: '#3B5EDA',
}
export const Fonts = {
    mainFont: '"Avenir Next", "Segoe UI", sans-serif',
    oldFont: '"Avenir Next", "Segoe UI", sans-serif',
    textFont: 'Darker Grotesque',
}